export default function ReportIntegrity({ report }) {
  const integrity = report?.integrity || {};
  const metrics = report?.metrics || {};
  const settings = report?.report_settings || {};
  const muted = "#64748b";
  const text = "#111827";

  const rows = [
    ["Audit Run", report?.audit_run_id || "—"],
    ["Report Version", integrity.report_version ?? report?.report_version ?? 1],
    ["Report Generated", report?.generated_at ? new Date(report.generated_at).toLocaleString() : "—"],
    ["Generated By", integrity.generated_by || "AuditOS Engine"],
    ["Engine Version", integrity.engine_version || report?.engine_version || "—"],
    ["Report Settings", `${settings.page_size || "A4"} · ${settings.orientation || "portrait"} · ${settings.theme || "minimal"} theme`],
    ["Controls Tested", integrity.controls_tested ?? metrics.controls_tested ?? "—"],
    ["Findings", integrity.findings_count ?? metrics.findings_count ?? "—"],
    ["Evidence Items", integrity.evidence_items ?? metrics.evidence_items ?? "—"],
    ["Report SHA-256", integrity.sha256 ? `${String(integrity.sha256).slice(0, 24)}…` : "—"],
  ];

  return (
    <div style={{ marginBottom: "30px", background: "#fefce8", border: "1px solid #fde68a", borderRadius: "8px", padding: "16px 18px" }}>
      <p style={{ margin: 0, fontSize: "11px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.4px", color: "#92400e" }}>
        Report Integrity
      </p>
      <p style={{ margin: "6px 0 0", fontSize: "12px", color: muted, lineHeight: 1.5 }}>
        This document is a controlled audit artifact. It was generated from a specific report snapshot; any re-generation of the report will increment the version below.
      </p>
      <div style={{ display: "grid", gridTemplateColumns: "200px 1fr", gap: "6px 16px", marginTop: "12px", fontSize: "12px" }}>
        {rows.map(([label, value]) => (
          <div key={label} style={{ display: "contents" }}>
            <span style={{ color: muted, fontWeight: 600 }}>{label}</span>
            <span style={{ color: text, wordBreak: "break-word" }}>{value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}